// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_hXs","cls2":"CiterightInline-cls2_VXq CiterightInline-cls1_hXs"};